import React, { useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import {
  FreeBetsWrapper,
  gameConfigStore,
  applicationStore,
  lobbyStore,
  GameHolder,
  GameBackside,
  TableUsersWinBets,
} from '@pascal/pascal-core';
import { GameLimitSection } from '../../components/gameLimitSection';
import { GameTitleSection } from '../../components/gameTitleSection';
import { GameCardHolderContainer } from '../../containers/gameCardHolderContainer';
import { CardHolderWebView } from '../../components/cardHolderView';
import { BetActionsPanel } from '../../components/betActionsPanel';
import ChipsWrapper from '../../containers/chipsWrapper';
import { DecisionTimer } from '../../components/decisionTimer';
import { WinPopup } from '../../components/winPopUp';
import DecisionButtonsWr from '../../containers/decisionButtonsWr';
import PlayerCardsSection from '../../components/playerCardsSection';
import DealerCardsSection from '../../components/DealerCardsSection';
import { CardCentralBox } from '../../components/cardCentralBox';
import { ShuffleCardsWrapper } from '../../components/shuffleCardWraper';
import { doBetStore } from '../../store/doBetStore';
import { gameStore } from '../../store/gameStore';
import { cardsStore } from '../../store/cardsStore';
import { RoomType } from '../../enums/roomType';

export const WebGameMain = observer(() => {
  const { isGuest } = applicationStore;
  const { lastBetModel } = doBetStore;
  const { isBetsClosed } = gameStore;
  const { gameTypes } = lobbyStore;
  const { gameTypeId } = gameConfigStore;
  const { isShuffle, cardInCentralBox } = cardsStore;

  const isShowDecisionTimer = !(isBetsClosed && !lastBetModel?.betModel);
  const isShowDecisionButtons = !(isGuest || (isBetsClosed && !lastBetModel?.betModel));

  const roomColor = useMemo(() => {
    const activeRoom = gameTypes?.find((game) => game.gameTypeId === gameTypeId);

    return activeRoom && activeRoom?.name ? RoomType[activeRoom?.name] : 'blue';
  }, [gameTypes, gameTypeId]);

  return (
    <GameHolder>
      <GameBackside />
      <div className='blackjack-main-container'>
        <div className={`blackjack ${roomColor}`}>
          <div className='blackjack-game-container'>
            <GameLimitSection />
            <GameTitleSection />
            <div className='blackjack-game-container-inner'>
              <DealerCardsSection />
              <GameCardHolderContainer innerComp={CardHolderWebView} />
              <ShuffleCardsWrapper />
              <CardCentralBox cardInCentralBox={cardInCentralBox} />
              {!isShuffle && (
                <div className='decisions-bets-row'>
                  <DecisionTimer isShowTimer={isShowDecisionTimer} />
                  <DecisionButtonsWr isShowDesicion={isShowDecisionButtons} />
                  <ChipsWrapper />
                </div>
              )}
              <div className='web-win-popup-holder'>
                <WinPopup />
              </div>
              <TableUsersWinBets />
              <PlayerCardsSection />
              <BetActionsPanel />
              <FreeBetsWrapper />
            </div>
          </div>
        </div>
      </div>
    </GameHolder>
  );
});
